const E = {};
const ajax = window.$.ajax;
E.getUserFromLocalStorage = function () {
    return new Promise((resolve, reject) => {
        if (localStorage.nuscastUser) {
            resolve(JSON.parse(localStorage.nuscastUser));
        } else {
            reject({msg: 'no user in localstorage'});
        }
    });
};
E.getComments = function (ID) {
    return new Promise((resolve, reject) => {
        ajax({
            url: E.getCommentUrl(ID),
            dataType: 'json',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getUserFromLogin = function (matric, pw) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/login',
            method: 'POST',
            data: {userID: matric, password: pw},
            dataType: 'json',
            success: function (d) {
                resolve(d);
                E.loginToIVLE(matric, pw);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getUserFromToken = function (token) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/token',
            method: 'POST',
            data: {token: token},
            dataType: 'json',
            success: function (d) {
                resolve(d);
                E.loginToPanopto();
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getReplies = function () {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/reply',
            method: 'GET',
            dataType: 'json',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.deleteReply = function (_id) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/reply',
            method: 'POST',
            dataType: 'json',
            data: {_id: _id},
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.logout = function() {
    ajax({
        url: '/api/logout',
        method: 'POST',
        data: {},
        dataType: 'json',
    });
};
E.getUserModules = function (user) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/profile',
            data: {},
            dataType: 'json',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.loginToIVLE = function (matric, pw) {
    return new Promise((resolve, reject) => {
        ajax({
            url: 'https://ivle.nus.edu.sg',
            dataType: 'jsonp',
            method: 'POST',
            data: '__LASTFOCUS=&__EVENTTARGET=ctl00$ctl00$ContentPlaceHolder1$btnSignIn&__EVENTARGUMENT=&__SCROLLPOSITIONX=0&__SCROLLPOSITIONY=0&ctl00$ctl00$ContentPlaceHolder1$userid='
            + matric + '&ctl00$ctl00$ContentPlaceHolder1$password=' + pw + '&ctl00$ctl00$ContentPlaceHolder1$chkRememberMe=on',
            complete: function () {
                resolve(E.loginToPanopto());
            }
        });
    });
};
E.loginToPanopto = function() {
    return Promise.all(['fac', 'med'].map((fac) => {
        return new Promise((resolve, reject) => {
            ajax({
                url: 'https://'+fac+'.weblecture.nus.edu.sg/Panopto/Pages/Auth/Login.aspx?instance=nus&AllowBounce=true',
                method: 'GET',
                dataType: 'jsonp',
                complete: function (d) {
                    resolve('swallow');
                }
            });
        });
    }));
};
E.getVideoList = function (ID) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/list',
            method: 'POST',
            dataType: 'json',
            data: {courseID: ID},
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getOpenMod = function () {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/open_mod',
            method: 'GET',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getOpenVideo = function (courseID) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/open_video',
            method: 'POST',
            dataType: 'json',
            data: {courseID: courseID},
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.sendComment = function (c, ID, isAdmin) {
    if (isAdmin)
        c.secret = 'nuscast';
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/comment/' + ID + '.json',
            dataType: 'json',
            data: c,
            method: 'POST',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.deleteComment = function (dbid, ID) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/delete/' + ID + '.json',
            dataType: 'json',
            data: {dbid: dbid},
            method: 'POST',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getGenComments = function (v) {
    return new Promise((resolve, reject) => {
        window.$.ajax({
            url: '/api/genComment',
            method: 'POST',
            dataType: 'json',
            data: {query: v.name.trim()},
            success: function (d) {
                resolve(d.data || []);
            },
            error: function (e) {
                reject(e);
            }
        });
    });
};
E.setBanlist = function (banlist) {
    return new Promise((resolve, reject) => {
        window.$.ajax({
            url: '/api/block',
            method: 'POST',
            dataType: 'json',
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({banlist: banlist}),
            success: function (d) {
                resolve(d);
            },
            error: function (e) {
                reject(e);
            }
        });
    });
};
E.getCommentUrl = function (ID) {
    return '/api/comment/' + ID + '.json';
};
E.getVideoInfo = function (ID) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/video',
            dataType: 'json',
            method: 'POST',
            data: {ID: ID},
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.getPromoVideos = function () {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/public',
            dataType: 'json',
            success: function (d) {
                resolve(d);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
};
E.bugReportSubmit = function(text) {
    return new Promise((resolve, reject) => {
        ajax({
            url: '/api/feedback',
            method: 'POST',
            data: {content: text},
            success: function (d) {
                resolve();
            },
            error: function (err) {
                reject();
            }
        });
    });
};
export default E;


// WEBPACK FOOTER //
// ./src/api/nuscastApi.js